import swal from "sweetalert";
import store from "../store";

// The AI endpoints (POST /note/ai-response and /note/ai-response/quick-note)
// refuse a request when the org has nothing left to spend:
//   403 { message: "Token quota exceeded" }              → balance is 0
//   404 { message: "Skai token record not found..." }    → no SkAi record at all
// Both used to surface as a generic failure ("Unable to generate response from
// SkAi." / "Oops! Something went wrong"), which reads like an outage instead of
// an empty balance. Detect them here so every AI call site can say what
// actually happened and where to fix it.

// Staff can't buy tokens — only the admin who owns the SkAi record can — so the
// call to action differs by role.
const isStaffUser = () => {
  const user = store.getState()?.profile?.profile?.user;
  return String(user?.type || "").toLowerCase() === "staff";
};

export const SKAI_OUT_OF_TOKENS_TITLE = "You're out of SkAi tokens";
export const SKAI_NOT_SET_UP_TITLE = "SkAi tokens not set up";

// Short line for inline UI (e.g. the compare panel), no swal involved.
export const SKAI_OUT_OF_TOKENS_SHORT =
  "You're out of SkAi tokens.";

export const getSkaiTokenError = (error) => {
  const status = error?.response?.status;
  const message = String(error?.response?.data?.message || "").toLowerCase();
  const staff = isStaffUser();

  if (status === 403 && message.includes("token quota")) {
    return {
      title: SKAI_OUT_OF_TOKENS_TITLE,
      text: staff
        ? "Your organization has used all of its SkAi tokens. Ask your administrator to buy more tokens or switch to unlimited before using SkAi again."
        : "You've used all of your SkAi tokens. Go to Settings → Billing & plan → SkAi tokens to buy more tokens or switch to unlimited.",
    };
  }

  if (status === 404 && message.includes("skai token")) {
    return {
      title: SKAI_NOT_SET_UP_TITLE,
      text: staff
        ? "SkAi isn't set up for your organization yet. Ask your administrator to purchase SkAi tokens."
        : "SkAi isn't set up for this account yet. Go to Settings → Billing & plan → SkAi tokens to buy tokens or go unlimited.",
    };
  }

  return null;
};

// Returns true when the error was a token problem and the alert was shown, so
// callers can skip their generic error handling.
export const showSkaiTokenError = (error) => {
  const tokenError = getSkaiTokenError(error);
  if (!tokenError) return false;
  swal({
    title: tokenError.title,
    text: tokenError.text,
    icon: "warning",
    dangerMode: false,
  });
  return true;
};
